import React from 'react';

const ProviderThumbnail = ({ title, id, imageUrl, linkUrl, providerName, providerTitle, history, match }) => (
    <div className="col-md-3 mb-4 centered-div" onClick={() => history.push(`${match.url}${linkUrl}`)}>
        <a href={`/providers/${linkUrl}`}>
            <div className="card">
                <img src={`${imageUrl}`} className="card-img-top" alt={`Dr. ${providerName.split(" ")[0]}`} />
                <div className="card-body">
                    <h2 style={{ fontSize: '20px' }} className="card-title">{providerName}</h2>
                    <p className="card-text">{providerTitle}</p>
                </div>
            </div>
        </a>
    </div>
)

export default ProviderThumbnail;
